import React from 'react';
import { Calendar } from 'lucide-react';

const ONEDOC_URL = "https://www.onedoc.ch/fr/cabinet-de-groupe/vevey/ebdj4/nutri-centre-riviera";

const MobileStickyCTA = () => {
  return (
    <a
      href={ONEDOC_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Prendre rendez-vous"
      data-testid="mobile-sticky-cta"
      className="mobile-sticky-cta"
      style={{
        position: 'fixed',
        bottom: '1rem',
        left: '1rem',
        right: '1rem',
        zIndex: 997,
        background: 'var(--accent-primary)',
        color: 'white',
        textDecoration: 'none',
        padding: '0.95rem 1.25rem',
        borderRadius: '999px',
        display: 'none',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '0.65rem',
        fontWeight: 600,
        fontSize: '1rem',
        boxShadow: '0 8px 24px rgba(61, 84, 70, 0.4)'
      }}
    >
      <Calendar size={18} />
      Prendre rendez-vous
      <style>{`
        @media (max-width: 768px) {
          .mobile-sticky-cta {
            display: flex !important;
          }
        }
      `}</style>
    </a>
  );
};

export default MobileStickyCTA;
